/**
 * THE SHOP'S CAMPAIGNS, REMEMBERED FOR A MINUTE — one store for two doors.
 *
 * Every page that shows a shop reads `GET /config/salon-by-slug/:slug`, and the
 * campaigns ride on that payload. The cart drawer needs the same list but is
 * not a page and holds no payload, so `getSalonBySlug` leaves the answer here
 * and `hooks/useShopCampaigns` reads it before it asks the server itself —
 * which is how a shopper browsing the shop with a full cart costs no second
 * salon request. Kept in its own module because `storeApi` must not import a
 * React hook, and the hook must not own state the API layer writes.
 */
export const SHOP_CAMPAIGNS_FRESH_MS = 60 * 1000;

const entries = new Map(); // slug -> { at, campaigns } | { promise }

export function rememberShopCampaigns(slug, campaigns) {
  if (!slug || !Array.isArray(campaigns)) return;
  entries.set(slug, { at: Date.now(), campaigns });
}

export function shopCampaignsEntry(slug) {
  return slug ? entries.get(slug) || null : null;
}

export function setShopCampaignsEntry(slug, entry) {
  if (!slug) return;
  if (entry) entries.set(slug, entry);
  else entries.delete(slug);
}

export function clearShopCampaigns() {
  entries.clear();
}
